var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#242938",
    rx: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_254)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_101_254)",
    fillRule: "evenodd",
    d: "M127.849 185.237C72.8422 185.237 28.2502 155.372 28.2502 118.533C28.2502 81.6931 72.8422 51.8287 127.849 51.8287C182.856 51.8287 227.447 81.6931 227.447 118.533C227.447 155.372 182.856 185.237 127.849 185.237ZM143.094 77.9077C101.284 77.9077 67.3906 98.3243 67.3906 123.509C67.3906 148.694 101.284 169.111 143.094 169.111C184.904 169.111 215.759 155.153 215.759 123.509C215.759 91.876 184.904 77.9077 143.094 77.9077Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_101_254)",
    fillRule: "evenodd",
    d: "M179.934 155.144C179.934 155.144 185.962 156.963 189.464 158.735C190.679 159.35 192.782 160.577 194.298 162.188C195.784 163.766 196.508 165.365 196.508 165.365L220.265 205.42L181.868 205.437L163.912 171.718C163.912 171.718 160.235 165.401 157.972 163.569C156.085 162.041 155.28 161.497 153.414 161.497C152.116 161.497 144.291 161.497 144.291 161.497L144.298 205.413L110.321 205.427V93.2481H178.553C178.553 93.2481 209.63 93.8086 209.63 123.376C209.63 152.943 179.934 155.144 179.934 155.144ZM165.155 117.581L144.585 117.568L144.575 136.643L165.155 136.636C165.155 136.636 174.685 136.606 174.685 126.933C174.685 117.065 165.155 117.581 165.155 117.581Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_254",
    x1: 28.25,
    x2: 151.612,
    y1: 51.829,
    y2: 236.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84838B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_254",
    x1: 110.321,
    x2: 222.487,
    y1: 93.248,
    y2: 203.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#276DC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165CAA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 154.972,
    fill: "#fff",
    transform: "translate(28 51)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRDark);
export default __webpack_public_path__ + "static/media/R-Dark.2e43a909c257279cb3b73384df4d74cc.svg";
export { ForwardRef as ReactComponent };